module.exports = __webpack_public_path__ + "static/media/Layout24.1339dc8b.png";